import styled from 'styled-components';

export const DwtcVAApplicationProcessWrapper = styled.section``;
export const DwtcVAApplicationProcessDesktopWrapper = styled.div`
  background-color: #f7f7f7;
  padding-top: 100px;
  padding-bottom: 100px;
  @media (max-width: 992px) {
    padding-top: 40px;
    padding-bottom: 30px;
  }
  @media (max-width: 992px) {
    padding-left: 25px;
    padding-right: 25px;
  }
  display: block;
  @media (max-width: 992px) {
    display: none;
  }
`;
export const DwtcVAApplicationProcessMobileWrapper = styled.div`
  background-color: #f7f7f7;
  padding-top: 100px;
  padding-bottom: 100px;
  @media (max-width: 992px) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  @media (max-width: 992px) {
    padding-left: 25px;
    padding-right: 25px;
  }
  display: none;
  @media (max-width: 992px) {
    display: block;
  }
`;
export const DwtcVAApplicationProcessHeader = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  text-align: center;
  @media (max-width: 767px) {
    row-gap: 16px;
  }
`;
export const DwtcVAApplicationProcessButton = styled.button`
  padding: 20px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  column-gap: 20px;
  width: 100%;
  background: #ce435b;
  border: none;
  outline: none;
  &[dir='ltr'] {
    text-align: left;
  }
  &[dir='rtl'] {
    text-align: right;
  }
  h3 {
    font-size: 14px;
    line-height: 17px;
    margin: 0px;
    color: #fff;
  }
  .arrow-down {
    border: solid white;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
  }
  .arrow-up {
    border: solid white;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(-135deg);
  }
`;
export const DwtcVAApplicationProcessHeaderTitle = styled.h2`
  margin: 0px;
  font-size: 30px;
  line-height: 50px;
  color: #000;
  @media (max-width: 767px) {
    font-size: 16px;
    line-height: 16px;
  }
`;
export const DwtcVAApplicationProcessHeaderText = styled.p`
  margin: 0px;
  font-size: 14px;
  color: #898989;
  line-height: 20px;
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const DwtcVAApplicationProcessBody = styled.div`
  padding-top: 56px;
  max-width: 1596px;
  position: relative;
  margin: 0px auto;
  &[dir='ltr'] {
    @media (max-width: 1600px) {
      padding-left: 30px;
      padding-right: 17px;
    }
  }
  &[dir='rtl'] {
    @media (max-width: 1600px) {
      padding-right: 30px;
      padding-left: 17px;
    }
  }

  @media (max-width: 1279px) {
    padding-left: 40px;
    padding-right: 40px;
  }
  @media (max-width: 992px) {
    padding-left: 0px;
    padding-right: 0px;
  }
  @media (max-width: 767px) {
    padding-top: 24px;
  }
  &[dir='ltr'] {
    .swiper-wrapper {
      .swiper-slide {
        &:last-child {
          .card-text-wrapper {
            padding-right: 0px;
          }
          .card-number {
            &:before {
              content: '';
              width: 0%;
            }
          }
        }
        .card-number {
          display: flex;
          justify-content: center;
          &:before {
            content: '';
            width: 100%;
            height: 1px;
            background-color: #ce435b;
            position: absolute;
            left: 50%;
            top: 50%;
            display: block;
          }
        }
      }
    }
  }
  &[dir='rtl'] {
    .swiper-wrapper {
      .swiper-slide {
        &:last-child {
          .card-text-wrapper {
            padding-left: 0px;
          }
          .card-number {
            &:before {
              content: '';
              width: 0%;
            }
          }
        }
        .card-number {
          display: flex;
          justify-content: center;
          &:before {
            content: '';
            width: 100%;
            height: 1px;
            background-color: #ce435b;
            position: absolute;
            right: 50%;
            top: 50%;
            display: block;
          }
        }
      }
    }
  }
`;
export const DwtcVAApplicationProcessAccordion = styled.div`
  border-bottom: 1px solid #fff;
`;
export const SwiperSlideCard = styled.div`
  width: 267px;
  display: flex;
  flex-direction: column;
  row-gap: 31px;
  @media (max-width: 1600px) {
    width: 100%;
  }
  @media (max-width: 767px) {
    row-gap: 15px;
  }
`;
export const SwiperSlideCardTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 31px;
  @media (max-width: 767px) {
    row-gap: 15px;
  }
  &[dir='ltr'] {
    padding-right: 24px;
  }
  &[dir='rtl'] {
    padding-left: 24px;
  }
  @media (max-width: 1600px) {
    &[dir='ltr'] {
      padding-right: 30px;
    }
    &[dir='rtl'] {
      padding-left: 30px;
    }
  }
`;
export const SwiperSlideCardSubtitle = styled.h3`
  position: relative;
  margin: 0px;
  &[dir='ltr'] {
    font-family: 'Baskerville';
  }
  span {
    width: 50px;
    height: 50px;
    background: #ce435b;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 35px;
    font-weight: 400;
    margin: 0px;
    z-index: 5;
    position: relative;
    @media (max-width: 1200px) {
      width: 40px;
      height: 40px;
      font-size: 30px;
    }
    @media (max-width: 992px) {
      font-size: 26px;
    }
    @media (max-width: 567px) {
      font-size: 22px;
      width: 35px;
      height: 35px;
    }
  }
`;
export const SwiperSlideCardtitle = styled.h3`
  color: #ce435b;
  font-weight: 400;
  line-height: 24px;
  margin: 0px;
  min-height: 48px;

  &[dir='ltr'] {
    font-size: 18px;
  }

  &[dir='rtl'] {
    font-size: 16px;
  }

  @media (max-width: 1600px) {
    min-height: 75px;
  }
`;
export const SwiperSlideCardText = styled.div`
  color: #898989;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  &[dir='ltr'] {
    ul {
      padding-left: 15px;
    }
  }
  &[dir='rtl'] {
    ul {
      padding-right: 15px;
    }
  }
  ul {
    margin: 0px;
  }
  @media (max-width: 992px) {
    padding: 20px;
    background-color: #fff;
    border: 1px solid #e5e7eb;
    border-top: none !important;
    font-size: 13px;
    line-height: 18px;
    &[dir='ltr'] {
      text-align: left;
    }
    &[dir='rtl'] {
      text-align: right;
    }
  }
`;
export const DwtcVAApplicationProcessDisclamier = styled.div`
  padding-top: 92px;
  @media (max-width: 992px) {
    padding-top: 24px;
  }
  p {
    max-width: 1121px;
    margin: 0px auto;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #898989;
    strong {
      color: #000;
      font-weight: 300;
    }
    @media (max-width: 768px) {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;
export const DWTCVASliderButton = styled.div``;

export const PrevButton = styled.button`
  @media (min-width: 1280px) {
    display: none;
  }
  outline: none;
  border: none;
  background: none;
  position: absolute;
  top: 25%;
  cursor: pointer;
  height: 35px;
  width: 35px;
  left: -10px;
  background: #ebebeb;
  border-radius: 50%;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 992px) {
    left: 0px;
  }
  svg {
    width: 10px;
    height: 16px;
    margin-top: 3px;
  }
`;
export const NextButton = styled.button`
  @media (min-width: 1280px) {
    display: none;
  }
  outline: none;
  border: none;
  background: none;
  position: absolute;
  top: 25%;
  right: -10px;
  cursor: pointer;
  height: 35px;
  width: 35px;
  background: #ebebeb;
  border-radius: 50%;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 992px) {
    right: 0px;
  }
  svg {
    width: 10px;
    height: 16px;
  }
`;
